<script lang="ts">
import { defineComponent } from "vue";
import ProduktKarte from "@/components/cross-selling/ProduktKarte.vue";

export default defineComponent({
  name: "CrossSelling",
  components: { ProduktKarte },
  props: {
    produkte: Array,
  },
  setup(props) {
    return {
      props,
    };
  },
});
</script>

<template>
  <section class="u-pad-b-2">
    <h2 class="u-mar-t-0 u-pad-t-3 u-mar-b-2 u-text-align-center">Das könnte Sie auch interessieren</h2>

    <div class="o-grid">
      <produkt-karte v-for="produkt in props.produkte" v-bind:key="produkt" :produkt="produkt" />
    </div>
  </section>
</template>
